/* eslint-disable @typescript-eslint/no-namespace */
/**
 * Static enums extracted from: @tencent/tpro_rmonitor_product_manager_product_user
 * DO NOT EDIT MANUALLY — run "npm run gen:proto-enums" to regenerate.
 *
 * Zero dependencies — only static enum definitions.
 * Supports nested namespace access: enumTrpc.rmonitor.web_server.IssueType
 */

export namespace enumTrpc {
  export namespace rmonitor {
    export namespace product_manager {
      export enum ExpireStrategy {
        STRATEGY_UNKNOW = 0,
        STRATEGY_ALL_USER = 1,
        STRATEGY_ALL_ADMIN = 2,
        STRATEGY_ALL_DEVELOPER = 3,
        STRATEGY_ALL_OPERATOR = 4,
      }

      export enum RoleID {
        INVADER = 0,
        ADMIN = 1,
        DEVELOPER = 2,
        OPERATOR = 3,
      }

    }

  }

}
